import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

if ("serviceWorker" in navigator) {
  // Force any already-waiting SW to activate immediately
  const activateWaitingSW = (registration: ServiceWorkerRegistration) => {
    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }
  };

  navigator.serviceWorker.ready.then((registration) => {
    // Activate any SW that is already waiting
    activateWaitingSW(registration);

    // Check for updates immediately and every 10 seconds
    registration.update().catch(() => {});
    setInterval(() => registration.update().catch(() => {}), 10 * 1000);

    // When a new SW installs, force it to activate immediately
    registration.addEventListener("updatefound", () => {
      const newWorker = registration.installing;
      if (newWorker) {
        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed") {
            activateWaitingSW(registration);
          }
        });
      }
    });

    // When a new SW finishes installing and takes control, reload to apply it
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      window.location.reload();
    });
  }).catch(() => {});

  // Also check for updates when the user returns to the tab
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      navigator.serviceWorker.ready.then((reg) => {
        reg.update().catch(() => {});
        activateWaitingSW(reg);
      }).catch(() => {});
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
